import { ButtonProps } from "@mui/material";
import { AppPrimaryButton } from "../../../ui/buttons";
import { useModalContext } from "../../ModalProvider";

type SuccessModalButtonProps = ButtonProps;

export const SuccessModalButton = ({
  children,
  ...props
}: SuccessModalButtonProps) => {
  const { closeModal } = useModalContext();
  const closeSuccessAndResetModals = () => {
    closeModal();
    closeModal();
  };

  return (
    <AppPrimaryButton
      onClick={closeSuccessAndResetModals}
      className={"w-full"}
      {...props}
    >
      {children}
    </AppPrimaryButton>
  );
};
